import { LocationPaths, UhcPath } from 'location.types'
import { RouteObject } from 'react-router'

export const uhc: RouteObject = {
  path: LocationPaths.Uhc,
  children: [
    {
      lazy: async () => {
        const { SecureDetailsLayout } = await import('components/PageLayout/SecureDetailsLayout')
        return { element: <SecureDetailsLayout headerProps={{ hideBorder: true }} /> }
      },
      children: [
        {
          path: UhcPath.Auth,
          lazy: async () => ({ Component: (await import('screens/Uhc')).Auth })
        },
        {
          path: UhcPath.Error,
          lazy: async () => ({ Component: (await import('screens/Uhc')).ErrorScreen })
        },
        {
          path: UhcPath.SignUp,
          lazy: async () => ({ Component: (await import('screens/Uhc')).SignUp })
        },
        {
          path: UhcPath.SignIn,
          lazy: async () => ({ Component: (await import('screens/Uhc')).SignIn })
        }
      ]
    },
    {
      lazy: async () => ({
        Component: (await import('screens/Uhc/UhcOnboardingLayout')).UhcOnboardingLayout
      }),
      children: [
        {
          path: UhcPath.PhoneNumber,
          lazy: async () => ({ Component: (await import('screens/Uhc')).ConfirmPhoneNumber })
        },
        {
          path: UhcPath.ProgramEligibility,
          lazy: async () => ({ Component: (await import('screens/Uhc')).ProgramEligibility })
        },
        {
          path: UhcPath.Questionnaire,
          lazy: async () => ({
            Component: (await import('screens/Survey')).QuestionnaireRoute
          })
        },
        {
          path: UhcPath.Goal,
          lazy: async () => ({ Component: (await import('screens/Uhc')).Goal })
        },
        {
          path: UhcPath.ConfirmPurchase,
          lazy: async () => ({ Component: (await import('screens/Uhc')).ConfirmPurchase })
        },
        {
          path: UhcPath.ScheduleCall,
          lazy: async () => ({ Component: (await import('screens/Uhc')).ScheduleCallStep })
        },
        {
          path: UhcPath.CoachingGoalsStart,
          lazy: async () => ({ Component: (await import('screens/Uhc')).CoachingGoalsStartScreen })
        },
        {
          path: UhcPath.Completed,
          lazy: async () => ({
            Component: (await import('screens/VideoCalls/FlowCompleted')).FlowCompleted
          })
        }
      ]
    }
  ]
}
